import { useEffect } from 'react';
import DataGridRotateEffects from './DataGridRotateEffects';
import { getCultures } from 'services/API/Cooperative';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';
import { toast } from 'react-toastify';

const RotateEffectsDataGridCooperative = ({ cultures, setCooperativeCultures, ownerId, from }) => {
  const { isOrganic } = useToggleSwitch(from, 'rotateEffects', () => {}, ownerId, null, null);

  const refreshData = (isOrganic, ownerId) => {
    if (!ownerId) {
      ownerId = localStorage.getItem('cooperative');
    }
    getCultures(ownerId, isOrganic)
      .then((res) => {
        setCooperativeCultures(res?.data?.data?.sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch((err) => {
        toast.error(err.data);
      });
  };

  useEffect(() => {
    refreshData(isOrganic, ownerId);
  }, [ownerId]);

  return (
    <DataGridRotateEffects
      from={from}
      cultures={cultures?.filter((culture) => culture.isCustomized === true)}
      ownerId={ownerId}
      refreshData={refreshData}
    />
  );
};

export default RotateEffectsDataGridCooperative;
